export const host =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080/api"
    : process.env.PUBLIC_URL + "/api";
